import { FormulaName, ValueType } from '../../kpi-dashboard/types/response';

export const DASHBOARD_KEY = 'sales_marketing_dashboard';

export const FORMULA_OPTIONS: { value: FormulaName; label: string }[] = [
  { value: FormulaName.MIN_LEADS_FROM_BUDGET, label: 'Min. Leads aus Budget' },
  { value: FormulaName.MIN_START_TRIAL_OUTBOUND, label: 'Min. Start Trial Outbound' },
  { value: FormulaName.MIN_START_TRIAL_INBOUND, label: 'Min. Start Trial Inbound' },
  { value: FormulaName.MIN_CLOSES_OUTBOUND, label: 'Min. Closes Outbound' },
  { value: FormulaName.MIN_CLOSES_INBOUND, label: 'Min. Closes Inbound' }
];

export const VALUE_TYPE_UNITS: Record<ValueType, string | null> = {
  currency: '€',
  percentage: '%',
  integer: null,
  decimal: null
};
